document.addEventListener('DOMContentLoaded', function () {
    // 创建 IntersectionObserver 实例
    window.YGImageLoader = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const newImg = new Image();
          newImg.onload = () => {
            img.src = newImg.src;
            img.removeAttribute('data-src');  // 如果只需要加载一次
            img.removeAttribute('srcset');  
            observer.unobserve(img);          // 停止观察该元素
          }
          newImg.src = img.getAttribute('data-src');
        }
      });
    }, { 
      rootMargin: "50px", // 预加载距离视口 50px 的图片
    });
  
    class YGImage extends HTMLElement {
        constructor() {
            super()
            this.init()
        }
        init() {
            // 这里放置初始化逻辑
            this.loaderImg()
        }
  
        get images() {
          return this.querySelectorAll('img[data-src]')
        }
  
        loaderImg () {
            // 这里放置自定义逻辑
            this.images.forEach((img) => {
              window.YGImageLoader.observe(img)
            })
        }
    }
    if (!window.customElements.get('yg-image')) {
        window.customElements.define('yg-image', YGImage)
    }

    class YGPopupBox extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (e) => {
          this.closePopup(e, () => {});
        });
      }
  
      openPopup($popupTemplate, fn) {
        // popupTemplate：需要替换的元素
        this.querySelector('.yg-popup-box-content-inner').innerHTML = $popupTemplate.innerHTML;
        document.querySelector('body').style.overflow = 'hidden';
        this.style.display = 'flex';
        fn();
      }
      closePopup(e, fn) {
        if (e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box') {
          this.style.display = 'none';
          this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
          document.querySelector('body').style.overflow = 'auto';
          fn();
        }
      }
    }
    if (!window.customElements.get('yg-popup-box')) {
      window.customElements.define('yg-popup-box', YGPopupBox);
    }
  
    class YGOpenPopup extends HTMLElement {
      constructor() {
        super();
        this.init();
        this.$popupBox = document.querySelector('yg-popup-box.yg-popup-box');
      }
      init() {
        // 这里放置初始化逻辑
        this.addEventListener('click', this.itemClick.bind(this));
      }
      itemClick() {
        // 这里放置自定义逻辑
        let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');
  
        $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => {});
        
      }
    }
    if (!window.customElements.get('yg-open-popup')) {
      window.customElements.define('yg-open-popup', YGOpenPopup);
    }

    class YGCountDown extends HTMLElement {
        constructor() {
            super()
            const rawDate = this.getAttribute('data-date');
            this.date = new Date(rawDate.includes('T') ? rawDate : rawDate.replace(/-/g, '/'));
            // this.date = new Date(this.getAttribute('data-date'))
            this.hideClass = this.getAttribute('data-hide-class')
            this.unit = this.getAttribute('data-show-unit')
            this.timer = null
        }
        connectedCallback() {
          this.timer = setInterval(this.updateCountdown.bind(this), 1000);
        }

        updateCountdown(){
          const now = new Date();
          const diff = this.date - now;
      
          if (diff <= 0) {
            // this.closest(`.${this.hideClass}`).classList.add('hide')
            this.closest(`.${this.hideClass}`).remove()
            clearInterval(this.timer);
            return;
          }
      
          // 计算天、时、分、秒
          const days = Math.floor(diff / (1000 * 60 * 60 * 24));
          const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
          const minutes = Math.floor((diff / (1000 * 60)) % 60);
          const seconds = Math.floor((diff / 1000) % 60);
        
          const daysText = `<span>${days<10?'0'+days:days}${this.unit?'d':''}</span>`;
          const hoursText = `<span>${hours<10?'0'+hours:hours}${this.unit?'h':''}</span>`;
          const minutesText = `<span>${minutes<10?'0'+minutes:minutes}${this.unit?'m':''}</span>`;
          const secondsText = `<span>${seconds<10?'0'+seconds:seconds}${this.unit?'s':''}</span>`;
          
          // 更新倒计时文本
          const countdownText = `${daysText}:${hoursText}:${minutesText}:${secondsText}`;
      
          this.innerHTML = countdownText;
        }
    }
    if (!window.customElements.get('yg-count-down')) {
        window.customElements.define('yg-count-down', YGCountDown)
    }

    class YGSwiper extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
          this.getAllAttributes()
          this.initSwiper()
        }

        getAllAttributes() {
          let booleanAttrs = ['loop', 'pagination', 'navigation'];
          let jsonAttrs = ['breakpoints']
          for (const attr of this.attributes) {
            if (attr.name.startsWith('data-')) {
              const cleanName = attr.name.slice(5); // 去除 'data-' 前缀
              
              let value = attr.value;
              if (booleanAttrs.includes(cleanName)) {
                value = value === 'true';
              } else if (jsonAttrs.includes(cleanName)) {
                value = this.parseSwiperBreakpoints(value);
              }

              this[cleanName] = value;
            }
          }
        }

        parseSwiperBreakpoints(str) {
          const result = {};
          const pairs = str.split(',');
        
          console.log("pairs",pairs)
          for (const pair of pairs) {
            const [breakpoint, values] = pair.split(':');
            if (!breakpoint || !values) continue;
        
            const [slides, space] = values.split('-').map(Number);
        
            result[breakpoint.trim()] = {
              slidesPerView: slides,
              spaceBetween: space
            };
          }

          console.log("result",   result)
          return result;
        }

        initSwiper() {
          const swiper = new Swiper(this, {
            // 这里放置 swiper 的配置
            loop: this['loop'],
            autoplay: this['autoplay']?{
              delay: this['autoplay'],
              stopOnLastSlide: false,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }:false,
            pagination: this['pagination']?{
              el: '.swiper-pagination',
              clickable: true,
            }:false,
            navigation: this['navigation']?{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }:false,
            breakpoints: this['breakpoints']?this['breakpoints']:false
          })
        }

    }
    if (!window.customElements.get('yg-swiper')) {
        window.customElements.define('yg-swiper', YGSwiper)
    }

    class YGMegaMenu extends HTMLElement {
        constructor() {
            super()
            this.itemClick = this.itemClick.bind(this);
        }

        connectedCallback() {
            this.$tabList = this.querySelectorAll('.yg-tab-item')
            this.$tabContentList = this.querySelectorAll('.yg-tab-content')

            this.$tabList.forEach(($tabTitle, i) => {
              $tabTitle.addEventListener('mouseover', ()=>this.itemClick($tabTitle, i));
            })

            this.$tabContentList.forEach(($tabContent)=>{
              let $tabTitleList = $tabContent.querySelectorAll('.yg-childlink-tab-item');
              let $tabContentList = $tabContent.querySelectorAll('.yg-childlink-content-item');

              $tabTitleList.forEach(($tabTitle, i) => {
                $tabTitle.addEventListener('mouseover', ()=>this.itemClick($tabTitle, i, $tabTitleList, $tabContentList));
              })
            })
        }

        itemClick($tabTitle, i, $tabTitleList, $tabContentList) {
            if ($tabTitle.classList.contains('active')) {
              return
            }
            // 这里放置自定义逻辑
            this.activateTab(i, $tabTitleList, $tabContentList);
        }

        activateTab(index, $tabTitleList, $tabContentList) {
          let $tabTitleListH = ($tabTitleList && $tabContentList)? $tabTitleList: this.$tabList
          let $tabContentListH = ($tabTitleList && $tabContentList)? $tabContentList: this.$tabContentList

          $tabTitleListH.forEach(tab => tab.classList.remove('active'));
          $tabContentListH.forEach(content => content.classList.remove('active'));
      
          if ($tabTitleListH[index]) {
            $tabTitleListH[index].classList.add('active');
          }
          if ($tabContentListH[index]) {
            $tabContentListH[index].classList.add('active');
          }
        }
    }
    if (!window.customElements.get('yg-mega-menu')) {
        window.customElements.define('yg-mega-menu', YGMegaMenu)
    }

    class YGProductTab extends HTMLElement {
        constructor() {
            super()
            this.itemClick = this.itemClick.bind(this);

            this.$tabTitleList = this.tabTitleList;
            this.$tabContentList = this.tabContentList;
        }

        get tabContentList() {
          if (!this.$tabContentList) {
            this.$tabContentList = this.querySelectorAll('.yg-tab-content')
          }
  
          return this.$tabContentList
        }
  
        get tabTitleList() {
          if (!this.$tabTitleList) {
            this.$tabTitleList = this.querySelectorAll('.yg-tab-title')
          }
  
          return this.$tabTitleList
        }

        connectedCallback() {
          this.$tabTitleList.forEach((item, i) => {
            item.addEventListener('click',  (e) => this.itemClick(e, i));
          })
        }
        disconnectedCallback() {
          this.$tabTitleList.forEach((item, i) => {
            item.removeEventListener('click', (e) => this.itemClick(e, i));
          })
        }

        itemClick(e, i) {
          // 这里放置自定义逻辑
          this.$tabTitleList.forEach(($tabTitle) => {
            $tabTitle.classList.remove('active')
          })
          this.$tabContentList.forEach(($tabContent) => {
            $tabContent.classList.remove('active')
          })
          this.$tabTitleList[i].classList.add('active')
          this.$tabContentList[i].classList.add('active')

          this.labelClick(i)
        }

        labelClick(i) {
          // 添加新的活动状态
          const parent = this.$tabTitleList[i].parentElement;
          if (parent && this.isScrollable(parent)) {
            const containerRect = parent.getBoundingClientRect();
            const targetRect = this.$tabTitleList[i].getBoundingClientRect();
            const scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 100;
        
            parent.scrollTo({
              left: scrollLeft,
              behavior: 'smooth'
            });
          }
        }
        
        isScrollable(el) {
          if (!el) return false;
        
          const style = window.getComputedStyle(el);
          const overflowY = style.overflowY;
          const overflowX = style.overflowX;
        
          const canScrollVertically = (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
          const canScrollHorizontally = (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;
        
          return canScrollVertically || canScrollHorizontally;
        }
    }
    if (!window.customElements.get('yg-product-tab')) {
        window.customElements.define('yg-product-tab', YGProductTab)
    }

    class YGDiscount extends HTMLElement {
      constructor() {
        super()
        this.init()
      }
      init() {
        // 这里放置初始化逻辑
        this.clickCopy()
    
      }
      clickCopy() {
        // 这里放置自定义逻辑
        let $copyBtn = this.querySelector('.product-info__discount-button')
        if (!$copyBtn) return
        let copyText = $copyBtn.getAttribute('data-code-text')
        let copyBtnText = $copyBtn.innerHTML
        $copyBtn.addEventListener('click', function() {
          navigator.clipboard.writeText(copyText).then(() => {
            $copyBtn.innerHTML = '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 24L9 19L19 29L39 9L44 14L19 39L4 24Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            setTimeout(()=>{
              $copyBtn.innerHTML = copyBtnText
            }, 3000)
          }, () => {
            $copyBtn.innerHTML = '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 11L11 6L24 19L37 6L42 11L29 24L42 37L37 42L24 29L11 42L6 37L19 24L6 11Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            setTimeout(()=>{
              $copyBtn.innerHTML = copyBtnText
            }, 3000)
          });
        })
      }

    }
    if (!window.customElements.get('yg-discount')) {
      window.customElements.define('yg-discount',YGDiscount)
    }

    class YGImageSwitch extends HTMLElement {
      constructor() {
          super()
          this.labelClick = this.labelClick.bind(this)
          
          this.$labelList = this.querySelectorAll('.yg-image-label')
          this.$contentList = this.querySelectorAll('.yg-image-content')
      }

      connectedCallback() {
          this.$labelList.forEach((label, index) => {
              label.addEventListener('click', () => this.labelClick(index))
          })
      }

      disconnectedCallback() {
          this.$labelList.forEach((label, index) => {
              label.removeEventListener('click', () => this.labelClick(index))
          })
      }

      labelClick(index) {
          // 移除所有活动状态
          this.$labelList.forEach(label => {
              label.classList.remove('active')
          })
          this.$contentList.forEach(content => {
              content.classList.remove('active')
          })

          // 添加新的活动状态
          this.$labelList[index].classList.add('active')
          this.$contentList[index].classList.add('active')
      }
    }

    if (!window.customElements.get('yg-image-switch')) {
        window.customElements.define('yg-image-switch', YGImageSwitch)
    }
    class YGBuyItNow extends HTMLElement {
      constructor() {
        super()
        this.init()
      }
      init() {
        // 这里放置初始化逻辑
        let _this = this
        let $button = _this.querySelector('.yg-buy-it-now-button')
        $button.addEventListener('click', () => _this.buttonClick())
      }
      buttonClick() {
        // 这里放置自定义逻辑
        let buyBtn = this.querySelector('.shopify-payment-button .shopify-payment-button__more-options') || this.querySelector('shopify-buy-it-now-button .shopify-payment-button__button');
        buyBtn.click();
      }
    }
    if (!window.customElements.get('yg-buy-it-now')) {
      window.customElements.define('yg-buy-it-now', YGBuyItNow)
    }

    class YGAnchor extends HTMLElement {
      constructor() {
          super()
          this.itemClick = this.itemClick.bind(this);
          this._sectionList = null;
      }

      get sectionTop(){
        // 只在第一次获取时缓存 section 列表
        if (!this._sectionList) {
          this._sectionList = document.querySelectorAll('#MainContent .shopify-section');
        }
      
        const sectionIndex = parseInt(this.getAttribute('data-section'), 10) - 1;
        const $section = this._sectionList[sectionIndex];

        if ($section) {
          return $section.offsetTop + 100;
        }

        return null;
      }

      connectedCallback() {
          this.addEventListener('click', this.itemClick);
      }

      disconnectedCallback() {
          this.removeEventListener('click', this.itemClick);
      }
      
      itemClick() {
        if (this.getAttribute('data-section-top') || this.sectionTop ) {
          window.scrollTo({
            top: this.getAttribute('data-section-top') || this.sectionTop,
            behavior: 'smooth',
          });
          
          const parent = this.parentElement;
          if (parent && this.isScrollable(parent)) {
            const containerRect = parent.getBoundingClientRect();
            const targetRect = this.getBoundingClientRect();
            const scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 120;
        
            parent.scrollTo({
              left: scrollLeft,
              behavior: 'smooth'
            });
          }
        }
      }

      isScrollable(el) {
        if (!el) return false;
      
        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        const overflowX = style.overflowX;
      
        const canScrollVertically = (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
        const canScrollHorizontally = (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;
      
        return canScrollVertically || canScrollHorizontally;
      }
    }
    if (!window.customElements.get('yg-anchor')) {
        window.customElements.define('yg-anchor', YGAnchor)
    }

    class YGAnchorTab extends HTMLElement {
        constructor() {
            super()
            this.$AnchorList = null;
            this.$YGButton = null;
            this.itemClick = this.itemClick.bind(this);
            this.addToCart = this.addToCart.bind(this);
        }
        connectedCallback() {
            this.$AnchorList = this.querySelectorAll('yg-anchor');
            this.$YGButton = this.querySelector('.yg-button');
            this.$AnchorList.forEach($Anchor => {
              $Anchor.addEventListener('click', (e) => this.itemClick(e));
            })
            this.$YGButton.addEventListener('click', this.addToCart);
        }
        disconnectedCallback() {
          this.$AnchorList.forEach($Anchor => {
            $Anchor.removeEventListener('click', (e) => this.itemClick(e));
          })
          this.$YGButton.removeEventListener('click', this.addToCart);
        }
        itemClick(e) {
            // 这里放置自定义逻辑
            this.$AnchorList.forEach($Anchor => {
                $Anchor.classList.remove('active');
            })
            e.target.classList.add('active');
        }
        addToCart() {
          console.log(this);
          
          this.classList.add('loading');
          const $addToCart = document.querySelector('.product .product-form__buttons [type="submit"][name="add"]');
          $addToCart.click();
        }
    }
    if (!window.customElements.get('yg-anchor-tab')) {
        window.customElements.define('yg-anchor-tab', YGAnchorTab)
    }

    class YGFaq extends HTMLElement {
    constructor() {
        super();
        this.labelContents = this.querySelectorAll('.label-content');
        this.faqTitleContainers = this.querySelectorAll('.faq-title-container');
        this.faqContainers = this.querySelectorAll('.faq-container');
    }

    connectedCallback() {
        this.init();
    }

    init() {
        // 初始化：显示第一个FAQ标题容器，隐藏其他
        this.faqTitleContainers.forEach((container, index) => {
            if (index === 0) {
                container.classList.add('active');
                this.labelContents[0].classList.add('active');
                
                // 默认展开第一个FAQ
                const firstFaqContainer = container.querySelector('.faq-container');
                const firstContent = firstFaqContainer?.nextElementSibling;
                if (firstFaqContainer && firstContent) {
                    firstFaqContainer.classList.add('active');
                    firstContent.classList.add('active');
                    const iconSvg = firstFaqContainer.querySelector('.icon-svg');
                    if (iconSvg) {
                        iconSvg.querySelector('.icon-down').style.display = 'none';
                        iconSvg.querySelector('.icon-up').style.display = 'block';
                    }
                }
            }
        });

        this.bindLabelEvents();
        this.bindFaqContainerEvents();
    }

    bindLabelEvents() {
        this.labelContents.forEach((label, index) => {
            label.addEventListener('click', () => {
                // 移除所有label的active类
                this.labelContents.forEach(l => l.classList.remove('active'));
                label.classList.add('active');

                const parent = label.parentElement;
                if (parent && this.isScrollable(parent)) {
                  const containerRect = parent.getBoundingClientRect();
                  const targetRect = label.getBoundingClientRect();
                  const scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 20;
              
                  parent.scrollTo({
                    left: scrollLeft,
                    behavior: 'smooth'
                  });
                }

                // 切换FAQ标题容器的显示
                this.faqTitleContainers.forEach((container, containerIndex) => {
                    if (containerIndex === index) {
                        container.classList.add('active');
                    } else {
                        container.classList.remove('active');
                        // 重置容器内所有FAQ的状态
                        this.resetFaqContainers(container);
                    }
                });
            });
        });
    }

    isScrollable(el) {
      if (!el) return false;
    
      const style = window.getComputedStyle(el);
      const overflowY = style.overflowY;
      const overflowX = style.overflowX;
    
      const canScrollVertically = (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
      const canScrollHorizontally = (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;
    
      return canScrollVertically || canScrollHorizontally;
    }

    resetFaqContainers(container) {
        const faqContainers = container.querySelectorAll('.faq-container');
        faqContainers.forEach(faq => {
            faq.classList.remove('active');
            const content = faq.nextElementSibling;
            if (content) content.classList.remove('active');
            const iconSvg = faq.querySelector('.icon-svg');
            if (iconSvg) {
                iconSvg.querySelector('.icon-down').style.display = 'block';
                iconSvg.querySelector('.icon-up').style.display = 'none';
            }
        });
    }

    bindFaqContainerEvents() {
        this.faqContainers.forEach(container => {
            container.addEventListener('click', () => {
                const content = container.nextElementSibling;
                const iconSvg = container.querySelector('.icon-svg');
                const isActive = container.classList.contains('active');

                // 关闭同组中的其他FAQ
                const parentContainer = container.closest('.faq-title-container');
                const siblingFaqs = parentContainer.querySelectorAll('.faq-container');
                
                siblingFaqs.forEach(sibling => {
                    if (sibling !== container) {
                        sibling.classList.remove('active');
                        const siblingContent = sibling.nextElementSibling;
                        if (siblingContent) {
                            siblingContent.classList.remove('active');
                        }
                        
                        const siblingSvg = sibling.querySelector('.icon-svg');
                        if (siblingSvg) {
                            siblingSvg.querySelector('.icon-down').style.display = 'block';
                            siblingSvg.querySelector('.icon-up').style.display = 'none';
                        }
                    }
                });

                // 切换当前FAQ状态
                container.classList.toggle('active');
                if (content) {
                    content.classList.toggle('active');
                }

                // 切换图标状态
                if (iconSvg) {
                    const iconDown = iconSvg.querySelector('.icon-down');
                    const iconUp = iconSvg.querySelector('.icon-up');
                    
                    if (isActive) {
                        iconDown.style.display = 'block';
                        iconUp.style.display = 'none';
                    } else {
                        iconDown.style.display = 'none';
                        iconUp.style.display = 'block';
                    }
                }
            });

            // 添加键盘可访问性
            container.setAttribute('tabindex', '0');
            container.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    container.click();
                }
            });
        });
    }

    disconnectedCallback() {
        // 清理事件监听器
        this.labelContents.forEach(label => {
            label.removeEventListener('click', null);
        });
        
        this.faqContainers.forEach(container => {
            container.removeEventListener('click', null);
            container.removeEventListener('keydown', null);
        });
    }
}

// 注册自定义元素
if (!window.customElements.get('yg-faq')) {
    window.customElements.define('yg-faq', YGFaq);
}

class YGSideNavigation extends HTMLElement {
  constructor() {
    super();
    this.headerOffset = 120;
    // 添加节流控制
    this.scrollThrottle = this.throttle(this.handleScroll.bind(this), 100);
  }

  connectedCallback() {
    this.initElements();
    this.setupNavigationClickHandlers();
    this.setStickyPosition();
    
    window.addEventListener('resize', () => this.setStickyPosition());
    window.addEventListener('scroll', this.scrollThrottle);
  }

  initElements() {
    this.navigationItems = this.querySelectorAll('.yg-side-navigation-item-desktop');
    this.h2Tags = document.querySelectorAll('.yg-main-container h2');
    this.stickyHeader = document.querySelector('sticky-header');
  }

  // 添加节流函数
  throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }

  // 新增：处理滚动时的高亮逻辑
  handleScroll() {
    const scrollPosition = window.scrollY + this.headerOffset + 0; // 添加一些偏移量使高亮更准确

    // 找到当前滚动位置对应的标题
    let currentSection = null;
    this.h2Tags.forEach((h2, index) => {
      const sectionTop = h2.offsetTop;
      const nextH2 = this.h2Tags[index + 1];
      const sectionBottom = nextH2 ? nextH2.offsetTop : document.documentElement.scrollHeight;

      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        currentSection = index;
      }
    });

    // 更新导航项的高亮状态
    if (currentSection !== null) {
      this.updateActiveState(this.navigationItems[currentSection]);
    }
  }

  setStickyPosition() {
    if (this.stickyHeader) {
      const headerHeight = this.stickyHeader.offsetHeight;
      this.style.top = `${headerHeight}px`;
      this.headerOffset = headerHeight;
    }
  }

  updatePosition() {
    if (this.stickyHeader) {
      const headerHeight = this.stickyHeader.offsetHeight;
      this.style.top = `${headerHeight}px`;
    }
  }

  setupNavigationClickHandlers() {
    this.navigationItems.forEach((item, index) => {
      if (index < this.h2Tags.length) {
        item.addEventListener('click', () => this.handleNavigationClick(item, index));
      }
    });
  }

  handleNavigationClick(item, index) {
    const targetH2 = this.h2Tags[index];
    const targetPosition = targetH2.getBoundingClientRect().top + window.pageYOffset - this.headerOffset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });

    this.updateActiveState(item);
  }

  updateActiveState(activeItem) {
    if (!activeItem) return;
    this.navigationItems.forEach(item => item.classList.remove('active'));
    activeItem.classList.add('active');
  }

  disconnectedCallback() {
    window.removeEventListener('resize', () => this.setStickyPosition());
    window.removeEventListener('scroll', this.scrollThrottle);
  }
}

// 注册自定义元素
if (!customElements.get('yg-side-navigation')) {
  customElements.define('yg-side-navigation', YGSideNavigation);
}

class YgShareButton extends HTMLElement {
    constructor() {
      super();
      
      // 初始化分享状态
      this.isSharing = false;

      // 获取分享按钮元素
      this.shareButton = this.querySelector('.article-share');
      
      // 设置分享URL
      this.urlToShare = document.location.href;

      // 检查是否支持原生分享API
      if (navigator.share) {
        this.shareButton.addEventListener('click', () => this.shareContent());
        this.shareButton.style.cursor = 'pointer';
      }
    }

    // 原生分享方法
    async shareContent() {
      if (this.isSharing) return;

      this.shareButton.style.opacity = '0.7';
      this.isSharing = true;

      try {
        await navigator.share({ 
          url: this.urlToShare, 
          title: document.title 
        });
      } catch (error) {
        console.error('分享失败:', error);
      } finally {
        this.isSharing = false;
        this.shareButton.style.opacity = '1';
      }
    }

    // 更新分享URL
    updateUrl(url) {
      this.urlToShare = url;
    }
  }

  // 注册自定义元素
if (!customElements.get('yg-share-button')) {
  customElements.define('yg-share-button', YgShareButton);
}

 class AccordionFaq extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    init() {
        this.initializeFaqItems();
        this.addEventListeners();
    }
    initializeFaqItems() {
        this.faqItems = this.querySelectorAll('.faq-container');
        this.descriptions = this.querySelectorAll('.description');
    }
    addEventListeners() {
        this.addEventListener('click', (e) => {
            const faqElement = e.target.closest('.faq-container');
            if (!faqElement) return;
            this.toggleFaq(faqElement);
        });
    }
    toggleFaq(faqElement) {
        const isActive = faqElement.classList.contains('active');
        
        this.closeAllFaqs();
        if (!isActive) {
            const description = faqElement.nextElementSibling;
            if (description && description.classList.contains('description')) {
                faqElement.classList.add('active');
                description.classList.add('active');
            }
        }
    }
    closeAllFaqs() {
          this.faqItems.forEach(faq => faq.classList.remove('active'));
          this.descriptions.forEach(desc => desc.classList.remove('active'));
      }
    }

    if (!window.customElements.get('accordion-faq')) {
      customElements.define('accordion-faq', AccordionFaq);
    }
    class YGViewMore extends HTMLElement {
      constructor() {
        super();
        this.moreHeight = 0;
        this.lessHeight = 0;
    
        this.content = this.querySelector('.yg-category-text');
        this.items = this.querySelectorAll('.yg-estimated-shipping-time');
        this.button = this.querySelector('.yg-view-more-content');
    
        this.expanded = false;
        this.itemClick = this.itemClick.bind(this);
        this.handleResize = this.debounce(this.handleResize.bind(this), 200);
      }
    
      connectedCallback() {
        if (!this.content || !this.button || this.items.length < 2) return;
    
        this.calcHeight();
        this.showMore();
        this.button.addEventListener('click', this.itemClick);
        window.addEventListener('resize', this.handleResize);
      }
    
      disconnectedCallback() {
        this.button.removeEventListener('click', this.itemClick);
        window.removeEventListener('resize', this.handleResize);
      }
    
      debounce(func, delay) {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => func.apply(this, args), delay);
        };
      }
    
      calcHeight() {
        this.moreHeight = this.content.scrollHeight;
    
        const secondItem = this.items[1];
        const firstItemTop = this.items[0].offsetTop;
        const secondItemTop = secondItem.offsetTop;
    
        // 高度为第一个到第二个元素的高度差
        this.lessHeight = secondItemTop - firstItemTop + 26;
      }
    
      showMore() {
        if (window.innerWidth < 750) {
          this.content.style.height = `${this.lessHeight}px`;
          this.button.classList.remove('hide');
          this.expanded = false;
          this.button.innerHTML = 'View More';
        } else {
          this.content.style.height = `${this.moreHeight}px`;
          this.button.classList.add('hide');
          this.expanded = true;
        }
      }
    
      itemClick() {
        this.expanded = !this.expanded;
        this.content.style.height = this.expanded
          ? `${this.moreHeight}px`
          : `${this.lessHeight}px`;
        this.button.innerHTML = this.expanded ? 'View Less' : 'View More';
      }
    
      handleResize() {
        this.calcHeight();
        this.showMore();
      }
    }
    
    if (!window.customElements.get('yg-view-more')) {
        window.customElements.define('yg-view-more', YGViewMore)
    }

})

!function(){let e=e=>!function e(t){if(t.length%4!=0||!/^[A-Za-z0-9+/=]+$/.test(t))return!1;try{return atob(t),!0}catch(r){return!1}}(e)?e:decodeURIComponent(escape(window.atob(e))),t={is_mark:"F",shop_domain:window?.Shopify?.shop||"",watermark_text:e("5rC05Y2w5paH5pys"),watermark_size:"20px",watermark_color:"#333333"},r=`${e("aHR0cHM6Ly9haXMueWlndW90ZWNoLmNvbS9zaXRlbWFyay9wcm90ZWN0aW9uL2FwaS92MS93YXRlcm1hcms=")}?shop_domain=${t.shop_domain}`,i=()=>{fetch(r).then(e=>{e.json().then(e=>{"success"===e.result&&(t={...t,...e,expire_time:Date.now()+864e5},"T"===e.is_mark&&n(t),localStorage.setItem("sitemark_watermark",JSON.stringify(t)))})})},s=null,n=e=>{if(s){s.disconnect();return}let{watermark_text:t,watermark_size:r,watermark_color:i}=e,o=document.createElement("div");o.style.position="absolute",o.style.zIndex="9999",o.style.left="50%",o.style.bottom="0",o.style.fontSize=r,o.style.color=i,o.innerHTML=t,setTimeout(()=>{let t=document.querySelector("footer");t?(t.style.position="relative",t.appendChild(o),(s=new MutationObserver(t=>{s.disconnect(),s=null,n(e)})).observe(t,{attributes:!0,childList:!0,subtree:!0})):(o.style.position="fixed",document.body.appendChild(o))},1e3)},o=localStorage.getItem("sitemark_watermark");if(o){let a=JSON.parse(o);t={...t,...a},a.expire_time&&a.expire_time<Date.now()?i():"T"===a.is_mark&&n(t)}else i()}();